/* eslint-disable camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Loader, Grid } from 'semantic-ui-react';
import { Bar, Pie, Line } from 'react-chartjs-2';
// import Masonry from 'react-masonry-css';
import { format } from 'date-fns';
import { EcoIcon } from '../../assets/icons';

import ChartCard from '../Chart/ChartCard';
import ChartPie from '../Chart/ChartPie';

import SocketStatusContainer from '../../containers/SocketStatusContainer';
import InfoCard from '../Common/InfoCard';
import InfoCardDevice from '../Common/InfoCardDevice';
import RoundIcon from '../Common/RoundIcon';

import { decimalAdjust } from '../../utils/math';

import styles from './Dashboard.module.scss';
// import globalStyles from '../../styles.module.scss';

const Dashboard = React.memo(
  ({ isInitializing, dashboard, devices, items, alertsOccur, onFetchDashboard }) => {
    const [t] = useTranslation();
    useEffect(() => {
      const newIntervalId = setInterval(() => {
        onFetchDashboard();
        clearInterval(newIntervalId);
      }, 15 * 60 * 1000);
    }, [dashboard]);

    return (
      <>
        {isInitializing ? (
          <Loader active size="massive" />
        ) : (
          <div className={styles.main}>
            <Grid className="spacing-small chart_pie_wrapper">
              {dashboard &&
                dashboard
                  .filter((f) => f.position <= 16)
                  .map((componentItem) => {
                    if (componentItem.component === 'type2') {
                      let deviceValue =
                        componentItem.values && componentItem.values[0]
                          ? componentItem.values[0].value
                          : 0;
                      const componentItemNames = componentItem.itemNames?.split(',');
                      if (
                        items.length > 0 &&
                        devices.length > 0 &&
                        componentItemNames?.length > 0
                      ) {
                        const Item = items.find((item) => item.itemName === componentItemNames[0]);
                        const deviceData = devices.find(
                          (device) => device.id === componentItem.deviceId,
                        );
                        if (Item && deviceData.items?.[Item.itemName]) {
                          deviceValue = (deviceData.items?.[Item.itemName] * 1).toLocaleString(
                            'en-GB',
                            {
                              minimumFractionDigits: Item.decimalPoint,
                              maximumFractionDigits: Item.decimalPoint,
                            },
                          );
                        }
                      }
                      deviceValue =
                        componentItem.values && componentItem.values[0]
                          ? parseFloat(deviceValue).toLocaleString('en-GB', {
                              minimumFractionDigits: componentItem.values[0].decimalPoint,
                              maximumFractionDigits: componentItem.values[0].decimalPoint,
                            })
                          : deviceValue;
                      const alertLevel =
                        alertsOccur.find(
                          (al) =>
                            al.deviceId === componentItem.deviceId &&
                            al.item.itemName === componentItem.itemNames,
                        )?.alertSetting?.alertLevel || 0;

                      return (
                        <Grid.Column
                          stretched
                          mobile={8}
                          tablet={8}
                          largeScreen={4}
                          widescreen={2}
                          key={componentItem.id}
                        >
                          <ChartPie
                            element={`gauge-${componentItem.position}`}
                            layout={1}
                            size="100%"
                            maxvalue={parseFloat(
                              (componentItem.values && componentItem.values[0]?.maxValue) || 0,
                            )}
                            value={parseFloat(deviceValue)}
                            label={componentItem.title}
                            unit={(componentItem.values && componentItem.values[0]?.unitName) || ''}
                            alertLevel={alertLevel}
                            valid={componentItem.values && componentItem.values[0]?.valid}
                          />
                        </Grid.Column>
                      );
                    }
                    return '';
                  })}
              {dashboard &&
                dashboard
                  .filter((f) => f.position <= 16)
                  .map((componentItem) => {
                    if (componentItem.component === 'type1') {
                      const Item = items.find((item) => item.itemName === componentItem.itemName);
                      return (
                        <Grid.Column
                          stretched
                          mobile={8}
                          tablet={8}
                          largeScreen={4}
                          widescreen={2}
                          key={componentItem.id}
                        >
                          <InfoCard title={componentItem.title} item={componentItem}>
                            <RoundIcon
                              icon={EcoIcon}
                              className="card-icon"
                              fillColor={Item.color}
                            />
                          </InfoCard>
                        </Grid.Column>
                      );
                    }
                    return '';
                  })}
            </Grid>
            <Grid className="spacing-small chart_pie_wrapper">
              {dashboard &&
                dashboard.map((componentItem) => {
                  switch (componentItem.component) {
                    case 'type3':
                      return (
                        <Grid.Column
                          stretched
                          mobile={8}
                          tablet={8}
                          largeScreen={4}
                          widescreen={2}
                          key={componentItem.id}
                        >
                          <InfoCardDevice
                            devices={devices}
                            items={items}
                            componentItem={componentItem}
                          />
                        </Grid.Column>
                      );
                    case 'type4': {
                      const data_values = [];
                      const data_yAxes = [];
                      componentItem.items.forEach((item) => {
                        const Item = items.find((it) => it.itemName === item.itemName);
                        let data_chart = {};
                        let item_yAxes = {};
                        const dataValue = item.value?.map((itValue) =>
                          itValue !== null ? (itValue * 1).toFixed(item.decimalPoint) : null,
                        );

                        const settingMaxY = item.max * 1 || Item.maxValue * 1;
                        const maxY = item.value ? Math.max(...item.value) : 0;
                        const exp = maxY >= 10 ? Math.floor(Math.log10(maxY)) : 1;
                        const newMaxY = decimalAdjust('ceil', (maxY + 1) * 1.2, exp); //  Math.floor((maxY * 1.5) / 100) * 100;

                        data_chart = {
                          type: 'bar',
                          yAxisID: item.itemName,
                          label: item.name,
                          data: dataValue,
                          // stack: 1,
                          backgroundColor: Item.color || '#00C58E',
                          spanGaps: true,
                        };
                        item_yAxes = {
                          id: item.itemName,
                          type: 'linear',
                          display: true,
                          scaleLabel: {
                            display: true,
                            labelString: Item.unitName,
                          },
                          ticks: {
                            min: item.min * 1 || Item.minValue * 1 || 0,
                            max: settingMaxY > maxY ? settingMaxY : newMaxY,
                          },
                        };

                        if (item.graph === 'line') {
                          data_chart = {
                            type: 'line',
                            label: item.name,
                            borderColor: Item.color || '#108775',
                            borderWidth: 1,
                            backgroundColor: Item.color || '#108775',
                            pointBorderColor: 'transparent',
                            fill: false,
                            yAxisID: item.itemName,
                            data: dataValue,
                            spanGaps: true,
                          };
                          item_yAxes = {
                            id: item.itemName,
                            type: 'linear',
                            display: true,
                            position: 'right',
                            scaleLabel: {
                              display: true,
                              labelString: Item.unitName,
                            },
                            ticks: {
                              min: item.min !== null ? item.min * 1 : Item.minValue * 1 || 0,
                              max: item.max !== null ? item.max * 1 : Item.maxValue * 1 || 100,
                            },
                          };
                        }
                        data_values.push(data_chart);
                        data_yAxes.push(item_yAxes);
                      });

                      if (data_values.length > 0) {
                        data_values.sort((a, b) => (a.type > b.type ? -1 : 1));
                      }

                      const data_labels = [];
                      if (componentItem.items[0]) {
                        for (let i = 0; i < componentItem.items[0]?.value?.length; i += 1) {
                          let label = `${i}:00`;
                          if (i <= 9) {
                            label = `0${i}:00`;
                          }
                          data_labels.push(label);
                        }
                      }

                      const data = {
                        labels: data_labels,
                        datasets: data_values,
                      };

                      const options = {
                        responsive: true,
                        scales: {
                          yAxes: data_yAxes,
                          xAxes: [
                            {
                              display: componentItem.size !== 'small',
                            },
                          ],
                        },
                      };
                      const options_small = {
                        responsive: true,
                        scales: {
                          yAxes: data_yAxes,
                          xAxes: [
                            {
                              display: false,
                            },
                          ],
                        },
                      };
                      const legend = {
                        display: componentItem.size !== 'small',
                      };
                      const legend_small = {
                        display: false,
                      };
                      const sizeOptions = {
                        small: 4,
                        medium: 8,
                        large: 16,
                      };
                      const heightOption = {
                        small: 120,
                        medium: 100,
                        large: 90,
                      };
                      return (
                        <Grid.Column
                          className={`chart_column ${styles.chart_column}`}
                          stretched
                          mobile={16} // mobile={16}
                          tablet={componentItem.size === 'small' ? 8 : 16} // tablet={8}
                          largeScreen={sizeOptions[componentItem.size]} // largeScreen={8}
                          widescreen={sizeOptions[componentItem.size]} // widescreen={4}
                          key={componentItem.id}
                        >
                          <div
                            className={`bg-white ${
                              (styles.dashboardChart, styles.lagewidth_display)
                            }`}
                          >
                            <ChartCard title={componentItem.title}>
                              <>
                                <Bar
                                  data={data}
                                  options={options}
                                  height={heightOption[componentItem.size]}
                                  legend={legend}
                                />
                              </>
                            </ChartCard>
                          </div>
                          <div
                            className={`bg-white ${
                              (styles.dashboardChart, styles.smallwidth_display)
                            }`}
                          >
                            <ChartCard title={componentItem.title}>
                              <>
                                <Bar
                                  data={data}
                                  options={options_small}
                                  // height={componentItem.size === 'large' ? 90 : 100}
                                  legend={legend_small}
                                />
                              </>
                            </ChartCard>
                          </div>
                        </Grid.Column>
                      );
                    }
                    case 'type5': {
                      let data_values = [];
                      const data_labels = [];
                      let data = {};
                      let options = {};
                      if (componentItem?.value?.[0]?.items) {
                        data_values = componentItem.value[0].items[0]
                          ? componentItem.value[0][componentItem.value[0].items[0].itemName]
                          : [];
                        data_values = data_values?.map((itValue) =>
                          (itValue * 1).toLocaleString('en-GB', {
                            minimumFractionDigits: componentItem.value[0].items[0].decimalPoint,
                            maximumFractionDigits: componentItem.value[0].items[0].decimalPoint,
                          }),
                        );
                        for (let i = 0; i < data_values.length; i += 1) {
                          let label = `${i}:00`;
                          if (i <= 9) {
                            label = `0${i}:00`;
                          }
                          data_labels.push(label);
                        }
                        let Item;
                        if (componentItem.value[0].items[0]) {
                          Item = items.find(
                            (it) => it.itemName === componentItem.value[0].items[0].itemName,
                          );
                        }
                        let data_chart = {
                          type: 'bar',
                          yAxisID: componentItem.item.itemName,
                          label: componentItem.value[0].items[0]
                            ? componentItem.value[0].items[0].name
                            : '',
                          data: data_values,
                          stack: 1,
                          backgroundColor: Item?.color || '#00C58E',
                        };

                        if (componentItem.item.graph === 'line') {
                          data_chart = {
                            type: 'line',
                            label: componentItem.value[0].items[0]
                              ? componentItem.value[0].items[0].name
                              : '',
                            borderColor: Item?.color || '#108775',
                            borderWidth: 1,
                            backgroundColor: Item?.color || '#108775',
                            pointBorderColor: 'transparent',
                            fill: false,
                            yAxisID: componentItem.item.itemName,
                            data: data_values,
                          };
                        }

                        data = {
                          labels: data_labels,
                          datasets: [data_chart],
                        };

                        options = {
                          responsive: true,
                          scales: {
                            yAxes: [
                              {
                                id: componentItem.value[0].items[0]
                                  ? componentItem.value[0].items[0].itemName
                                  : '',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                scaleLabel: {
                                  display: true,
                                  labelString: componentItem.value[0]?.items?.[0]?.unitName || '',
                                },
                                ticks: {
                                  min: componentItem.item?.min * 1 || 0,
                                  max: componentItem.item?.max * 1 || 100,
                                },
                              },
                            ],
                          },
                        };
                      }
                      const legend = {
                        display: false,
                      };

                      return (
                        <Grid.Column
                          mobile={16}
                          tablet={16}
                          largeScreen={16}
                          widescreen={4}
                          className={styles.chart_column}
                          stretched
                          key={componentItem.id}
                        >
                          <div className={`bg-white ${styles.dashboardChart}`}>
                            <ChartCard title={componentItem.title}>
                              <>
                                <Bar data={data} options={options} legend={legend} />
                              </>
                            </ChartCard>
                          </div>
                        </Grid.Column>
                      );
                    }
                    case 'type6': {
                      const data_labels = [];
                      const dataValue = [];
                      componentItem.items?.[0].valueAndTime?.forEach((vt) => {
                        dataValue.push(
                          vt.value?.toLocaleString('en-GB', {
                            minimumFractionDigits: componentItem.items?.[0].decimalPoint,
                            maximumFractionDigits: componentItem.items?.[0].decimalPoint,
                          }),
                        );
                        const time = format(new Date(vt.loggedAt), 'HH:mm:ss');
                        data_labels.push(time);
                      });

                      let Item;
                      if (componentItem?.items[0]) {
                        Item = items.find((it) => it.itemName === componentItem.items[0].itemName);
                      }
                      const data = {
                        labels: data_labels,
                        datasets: [
                          {
                            type: 'line',
                            label: '',
                            borderColor: Item?.color || '#108775',
                            borderWidth: 1,
                            backgroundColor: 'transparent',
                            pointBorderColor: 'transparent',
                            fill: false,
                            data: dataValue,
                            yAxisID: 'y-axis-1',
                          },
                        ],
                      };

                      const options = {
                        responsive: true,
                        animation: {
                          duration: 0,
                        },
                        scales: {
                          yAxes: [
                            {
                              type: 'linear',
                              display: true,
                              position: 'left',
                              id: 'y-axis-1',
                              scaleLabel: {
                                display: true,
                                labelString: componentItem.items?.[0].unitName,
                              },
                              ticks: {
                                min: componentItem.min || 0,
                                max: componentItem.max || 300,
                                display: true,
                              },
                            },
                          ],
                          xAxes: [
                            {
                              ticks: {
                                display: true,
                                autoSkip: true,
                                maxTicksLimit: 10,
                                stepSize: 90,
                              },
                            },
                          ],
                        },
                      };

                      const legend = {
                        display: false,
                      };

                      return (
                        <Grid.Column
                          mobile={16}
                          tablet={16}
                          largeScreen={16}
                          widescreen={16}
                          className={styles.chart_column}
                          key={componentItem.id}
                        >
                          <div className={`bg-white ${styles.dashboardChart}`}>
                            <ChartCard title={componentItem.title}>
                              <>
                                <Line
                                  data={data}
                                  options={options}
                                  legend={legend}
                                  height={25}
                                  background="#333"
                                />
                              </>
                            </ChartCard>
                          </div>
                        </Grid.Column>
                      );
                    }
                    case 'type7': {
                      const data_values = [];
                      const data_labels = [];
                      const data_bg_color = [];
                      const legends = [];
                      componentItem.items?.forEach((item) => {
                        data_values.push((item.sum * 1).toFixed(item.decimalPoint));
                        data_labels.push(`${item.name} (${item.unitName})`);
                        data_bg_color.push(item.color);
                        legends.push({ title: item.name, color: item.color });
                      });

                      const data = {
                        datasets: [
                          {
                            data: data_values,
                            backgroundColor: data_bg_color,
                            label: componentItem.title,
                          },
                        ],
                        labels: data_labels,
                      };

                      const options = {
                        responsive: true,
                      };

                      return (
                        <Grid.Column
                          mobile={16}
                          tablet={16}
                          largeScreen={8}
                          widescreen={4}
                          className={styles.chart_column}
                          stretched
                          key={componentItem.id}
                        >
                          <div className={`bg-white ${styles.dashboardChart}`}>
                            <ChartCard title={componentItem.title} className={styles.chartType7}>
                              <>
                                <Pie data={data} options={options} height={55} width={100} />
                              </>
                            </ChartCard>
                          </div>
                        </Grid.Column>
                      );
                    }
                    default:
                      return '';
                  }
                })}
            </Grid>
            <Grid className="spacing-small chart_pie_wrapper">
              {dashboard &&
                dashboard
                  .filter((f) => f.position > 16)
                  .map((componentItem) => {
                    if (componentItem.component === 'type2') {
                      let deviceValue =
                        componentItem.values && componentItem.values[0]
                          ? componentItem.values[0].value
                          : 0;
                      const componentItemNames = componentItem.itemNames?.split(',');
                      if (
                        items.length > 0 &&
                        devices.length > 0 &&
                        componentItemNames?.length > 0
                      ) {
                        const Item = items.find((item) => item.itemName === componentItemNames[0]);
                        const deviceData = devices.find(
                          (device) => device.id === componentItem.deviceId,
                        );
                        if (Item && deviceData.items?.[Item.itemName]) {
                          deviceValue = (deviceData.items?.[Item.itemName] * 1).toLocaleString(
                            'en-GB',
                            {
                              minimumFractionDigits: Item.decimalPoint,
                              maximumFractionDigits: Item.decimalPoint,
                            },
                          );
                        }
                      }
                      deviceValue =
                        componentItem.values && componentItem.values[0]
                          ? parseFloat(deviceValue).toLocaleString('en-GB', {
                              minimumFractionDigits: componentItem.values[0].decimalPoint,
                              maximumFractionDigits: componentItem.values[0].decimalPoint,
                            })
                          : deviceValue;
                      const alertLevel =
                        alertsOccur.find(
                          (al) =>
                            al.deviceId === componentItem.deviceId &&
                            al.item.itemName === componentItem.itemNames,
                        )?.alertSetting?.alertLevel || 0;

                      return (
                        <Grid.Column
                          stretched
                          mobile={8}
                          tablet={8}
                          largeScreen={4}
                          widescreen={2}
                          key={componentItem.id}
                        >
                          <ChartPie
                            element={`gauge-${componentItem.position}`}
                            layout={1}
                            size="100%"
                            maxvalue={parseFloat(
                              (componentItem.values && componentItem.values[0]?.maxValue) || 0,
                            )}
                            value={parseFloat(deviceValue)}
                            label={componentItem.title}
                            unit={(componentItem.values && componentItem.values[0]?.unitName) || ''}
                            alertLevel={alertLevel}
                            valid={componentItem.values[0]?.valid}
                          />
                        </Grid.Column>
                      );
                    }
                    return '';
                  })}
              {dashboard &&
                dashboard
                  .filter((f) => f.position > 16)
                  .map((componentItem) => {
                    if (componentItem.component === 'type1') {
                      const Item = items.find((item) => item.itemName === componentItem.itemName);
                      return (
                        <Grid.Column
                          stretched
                          mobile={8}
                          tablet={8}
                          largeScreen={4}
                          widescreen={2}
                          key={componentItem.id}
                        >
                          <InfoCard title={componentItem.title} item={componentItem}>
                            <RoundIcon
                              icon={EcoIcon}
                              className="card-icon"
                              fillColor={Item.color}
                            />
                          </InfoCard>
                        </Grid.Column>
                      );
                    }
                    return '';
                  })}
            </Grid>
            <Grid className={styles.wrapper}>
              {dashboard &&
                dashboard.map((componentItem) => {
                  if (componentItem.component === 'type8') {
                    const componentItemNames = componentItem.itemNames?.split(',');
                    const device = devices.filter((dv) => dv.id === componentItem.deviceId);
                    const selectedItems = items.filter(
                      (item) =>
                        componentItemNames.includes(item.itemName) &&
                        device[0]?.modelId === item.modelId,
                    );
                    const sumItems = selectedItems.map((item) => {
                      const daily =
                        componentItem.sum &&
                        !Number.isNaN(componentItem.sum[item.itemName]?.daily * 1)
                          ? (componentItem.sum[item.itemName]?.daily * 1).toLocaleString('en-GB', {
                              minimumFractionDigits: item.decimalPoint,
                              maximumFractionDigits: item.decimalPoint,
                            })
                          : '-';
                      const monthly =
                        componentItem.sum &&
                        !Number.isNaN(componentItem.sum[item.itemName]?.monthly * 1)
                          ? (componentItem.sum[item.itemName]?.monthly * 1).toLocaleString(
                              'en-GB',
                              {
                                minimumFractionDigits: item.decimalPoint,
                                maximumFractionDigits: item.decimalPoint,
                              },
                            )
                          : '-';
                      const yearly =
                        componentItem.sum &&
                        !Number.isNaN(componentItem.sum[item.itemName]?.yearly * 1)
                          ? (componentItem.sum[item.itemName]?.yearly * 1).toLocaleString('en-GB', {
                              minimumFractionDigits: item.decimalPoint,
                              maximumFractionDigits: item.decimalPoint,
                            })
                          : '-';
                      return {
                        id: item.id,
                        daily,
                        monthly,
                        yearly,
                        name: item.name,
                        unitName: item.unitName,
                      };
                    });

                    // const cols =
                    //   sumItems.length > 0 ? Math.floor(16 / (2 * sumItems.length)) * 2 : 8;

                    return sumItems.map((item) => (
                      <Grid.Column
                        stretched
                        mobile={16}
                        tablet={8}
                        largeScreen={8}
                        widescreen={4}
                        key={item.id}
                      >
                        <div className={styles.sumWrapper}>
                          <div
                            title={item.name}
                            className={classNames(
                              styles.wrapperType8,
                              styles.wrapperHeaderType8,
                              styles.wrapperLarge,
                            )}
                          >
                            {`${componentItem.title} - ${item.name}`}
                          </div>
                          <div
                            title={item.daily}
                            className={classNames(
                              styles.wrapperType8,
                              styles.wrapperValueType8,
                              styles.wrapperLarge,
                            )}
                          >
                            {t('common.components.totalToday')}: <strong>{item.daily}</strong>{' '}
                            {item.unitName}
                          </div>
                          <div
                            title={item.monthly}
                            className={classNames(
                              styles.wrapperType8,
                              styles.wrapperValueType8,
                              styles.wrapperLarge,
                            )}
                          >
                            {t('common.components.totalThisMonth')}: <strong>{item.monthly}</strong>{' '}
                            {item.unitName}
                          </div>
                          <div
                            title={item.yearly}
                            className={classNames(
                              styles.wrapperType8,
                              styles.wrapperValueType8,
                              styles.wrapperLarge,
                            )}
                          >
                            {t('common.components.totalThisYear')}: <strong>{item.yearly}</strong>{' '}
                            {item.unitName}
                          </div>
                        </div>
                      </Grid.Column>
                    ));
                  }
                  return '';
                })}
            </Grid>
          </div>
        )}
        <SocketStatusContainer />
      </>
    );
  },
);

Dashboard.propTypes = {
  isInitializing: PropTypes.bool.isRequired,
  dashboard: PropTypes.arrayOf(PropTypes.any).isRequired,
  devices: PropTypes.arrayOf(PropTypes.any).isRequired,
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  alertsOccur: PropTypes.arrayOf(PropTypes.any).isRequired,
  onFetchDashboard: PropTypes.func.isRequired,
};

export default Dashboard;
